export var AvailAbilityStep;
(function (AvailAbilityStep) {
    AvailAbilityStep["AvailabilityIndex"] = "AvailabilityIndex";
    AvailAbilityStep["FlexibleIndex"] = "FlexibleIndex";
    AvailAbilityStep["FlexibleTime"] = "FlexibleTime";
    AvailAbilityStep["UnavailabilitySummary"] = "UnavailabilitySummary";
    AvailAbilityStep["LimitedTime"] = "LimitedTime";
    AvailAbilityStep["AvailabilitySummary"] = "AvailabilitySummary";
})(AvailAbilityStep || (AvailAbilityStep = {}));
export var AvailabilityType;
(function (AvailabilityType) {
    AvailabilityType[AvailabilityType["Flexible"] = 1] = "Flexible";
    AvailabilityType[AvailabilityType["Limited"] = 2] = "Limited";
})(AvailabilityType || (AvailabilityType = {}));
export var FlexibleType;
(function (FlexibleType) {
    FlexibleType["NotAvailable"] = "NotAvailable";
    FlexibleType["AllTimeIsGood"] = "AllTimeIsGood";
})(FlexibleType || (FlexibleType = {}));
export var AvailabilityTimesTitle;
(function (AvailabilityTimesTitle) {
    AvailabilityTimesTitle["FlexibleTimeTitle"] = "Select all of the times that do not work for you";
    AvailabilityTimesTitle["LimitedTimeTitle"] = "Select all of the days and times that do work for you";
})(AvailabilityTimesTitle || (AvailabilityTimesTitle = {}));
export var AvailabilityTimesSubTitle;
(function (AvailabilityTimesSubTitle) {
    AvailabilityTimesSubTitle["FlexibleTimeSubTitle"] = "We will share this information with the specialist and they will avoid scheduling in these times.";
    AvailabilityTimesSubTitle["LimitedTimeSubTitle"] = "We will share this information with the specialist to assist in scheduling times.";
})(AvailabilityTimesSubTitle || (AvailabilityTimesSubTitle = {}));
export var SummaryScreenTitle;
(function (SummaryScreenTitle) {
    SummaryScreenTitle["UnavailableTimesTitle"] = "Unavailable times";
    SummaryScreenTitle["AvailableTimesTitle"] = "Available times";
})(SummaryScreenTitle || (SummaryScreenTitle = {}));
export var SummaryScreenSubTitle;
(function (SummaryScreenSubTitle) {
    SummaryScreenSubTitle["UnavailableTimesSubTitle"] = "These are the days and times that don\u2019t work for you. The specialist will reach out to schedule.";
    SummaryScreenSubTitle["AvailableTimesSubTitle"] = "These are the days and times that work for you. The specialist will reach out to schedule.";
})(SummaryScreenSubTitle || (SummaryScreenSubTitle = {}));
export var ContactKey;
(function (ContactKey) {
    ContactKey["Phone"] = "phone";
    ContactKey["FlagofPhonesForTextMessagingApproved"] = "flagofPhonesForTextMessagingApproved";
})(ContactKey || (ContactKey = {}));
export var CompareTime;
(function (CompareTime) {
    CompareTime["Morning"] = "11:00 AM";
    CompareTime["Afternoon"] = "6:00 PM";
})(CompareTime || (CompareTime = {}));
export var RecallCertifierType;
(function (RecallCertifierType) {
    RecallCertifierType[RecallCertifierType["OMManualCertifed"] = 1] = "OMManualCertifed";
    RecallCertifierType[RecallCertifierType["SystemCertifed"] = 2] = "SystemCertifed";
})(RecallCertifierType || (RecallCertifierType = {}));
